export default "__VITE_ASSET__CgkyCO7u__"